import { jsx as _jsx } from "react/jsx-runtime";
import { Tag } from '@dossierhq/design';
export function StatusTag({ className, status }) {
    return (_jsx(Tag, { className: className, color: status, children: status }));
}
//# sourceMappingURL=StatusTag.js.map